export const completionMessage = [
    { heading: 'Awesome! You’ve reviewed everything', content: 'Review again to practice with the same questions, or try another ‘note’' },
    { heading: 'Review Complete!', content: 'You can repeat this note again for a quick review, or try a different note.' },
    { heading: 'You’re doing great!', content: 'Keep reviewing this note for a better understanding, or go with a new note.' },
  ];